const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
function avatarCrop(width,height,view={}){
 if(!(width>0&&height>0))throw Error('Fotoğrafın boyutları okunamadı.');
 const zoom=clamp(Number(view.zoom)||1,.25,4),size=Math.min(width,height)/zoom;
 // Permit deliberate framing/margins in both axes; export uses the same white canvas.
 const x=clamp(Number.isFinite(view.x)?view.x:.5,0,1);
 const y=clamp(Number.isFinite(view.y)?view.y:.5,0,1);
 return {x,y,zoom,left:x*width-size/2,top:y*height-size/2,size};
}
module.exports={avatarCrop};
